import React, { ReactNode } from "react";
import { tesaGrey2 } from "../../../styles/colors";

const formatSampleName = (sampleName: string, sampleSuffix?: string): ReactNode => {
  if (sampleSuffix) {
    return (
      <>
        {sampleName} <span style={{ color: tesaGrey2 }}>{sampleSuffix}</span>{" "}
      </>
    );
  }
  return sampleName;
};

export default formatSampleName;
